import { useTranslation } from 'react-i18next';
import CheckCircleIcon from '@/assets/icons/in-app-check-circle.svg?react';
import CopyIcon from '@/assets/icons/in-app-copy.svg?react';
import { Text } from '@/components/base';

export const CopyLinkStatus = ({ isLinkCopied }: { isLinkCopied: boolean }) => {
  const { t } = useTranslation('activitySession');

  if (!isLinkCopied) {
    return <CopyIcon aria-hidden className="size-[22px] shrink-0" />;
  }
  return (
    <span className="flex shrink-0 items-center gap-1.5">
      <Text version="revamp-v1" variant="caption" is="span" className="font-medium text-revamp-grape-800">
        {t('in_app_browser_notice.link_copied')}
      </Text>
      <CheckCircleIcon aria-hidden className="size-[22px]" />
    </span>
  );
};
